import { useConversionTypeSelectOptions } from "components/UI/Selects/ConversionTypeSelectSearchable/useConversionTypeSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

export const ConversionTypeSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useConversionTypeSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.conversion_type"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
